// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"LoginForm_loginFormWrapper__Q1iNy","loginFormErrors":"LoginForm_loginFormErrors__IB5M6"};